import { render, staticRenderFns } from "./HeroSpace.vue?vue&type=template&id=426d5b7f&scoped=true"
import script from "./HeroSpace.vue?vue&type=script&lang=js"
export * from "./HeroSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426d5b7f",
  null
  
)

export default component.exports